export const toTitleCase = str => {
  if (!str) return '';
  return str.trim().replace(/\s+/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
}

export const validateEmail = email => {
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return (re.test(email));
}

export const formatPhone = phone => {
  if (!phone) return '';

  let formattedNumber;
  // Filter non numbers
  const regex = () => phone.replace(/[^0-9\.]+/g, "");
  // Set area code with parenthesis around it
  const areaCode = () => `(${regex().slice(0, 3)})`;
  
  // Set formatting for first six digits
  const firstSix = () => `${areaCode()} ${regex().slice(3, 6)}`;
  
  // Dynamic trail as user types
  const trailer = (start) => `${regex().slice(start, regex().length)}`;

  if (phone.length < 3) {
     // First 3 digits
     formattedNumber = regex();
  } else if (phone.length === 4) {
     // After area code
     formattedNumber = `${areaCode()} ${trailer(3)}`;
  } else if (phone.length === 5) {
     // When deleting digits inside parenthesis
     formattedNumber = `${areaCode().replace(")", "")}`;
  } else if (phone.length > 5 && phone.length < 9) {
     // Before dash
     formattedNumber = `${areaCode()} ${trailer(3)}`;
  } else if (phone.length >= 10) {
     // After dash
     formattedNumber = `${firstSix()}-${trailer(6)}`;
  } 

  return formattedNumber;
}
